export const blogRouteAction = context => {
    return { redirect: `/blog/` };
};
